<template>
    <v-row align="center" justify="center" class="fondo">

        <v-col cols="12" class="text-center">
            <div class="titleLogin m-b-md">
                <strong>Yaku</strong>SeLA
            </div>

            <div class="subTitleLogin">
                Plataforma web para la administración de los procesos de SeLA - Oruro
            </div>
<!--            <h1 style="color:red">SISTEMA DE PRUEBA</h1>-->
        </v-col>

        <v-col cols="12">
            <v-hover v-slot:default="{ hover }">
                <v-card
                        class="mx-auto"
                        max-width="450"
                        flat
                        :elevation="hover ? 5 : 2"
                >

                    <login-user @setMiUsuario="setMiUsuario" v-if="miusuario === ''"></login-user>
                    <template v-else>
                        <login-passowrd v-if="!cambioPass" :miusuario="miusuario" @setMiUsuario="setMiUsuario"
                                        @changePassword="changePassword" @setMiPassword="setMiPassword"
                                        @setToken="setToken"></login-passowrd>
                        <login-cambiar-password v-if="cambioPass" :miusuario="miusuario" :old_password="mipassword"
                                                :userToken="userToken" @setMiUsuario="setMiUsuario"
                                                @changePassword="changePassword"></login-cambiar-password>
                    </template>

                    <br>
                    <v-divider></v-divider>
                    <div class="pa-5 text-center grey--text">
                        Recuerde nunca revelar sus credenciales de inicio de sesión a nadie, ni anotar en ningún
                        lugar
                        visible
                    </div>
                    <v-card-text class="text-center text--white">
                        {{ new Date().getFullYear() }} — <strong> SELA ORURO</strong><br>
                    </v-card-text>
                </v-card>
            </v-hover>
        </v-col>

    </v-row>
</template>

<script>
    import LoginUser from "./loginUser";
    import LoginPassowrd from "./loginPassowrd";
    import LoginCambiarPassword from "./loginCambiarPassword";
    import {mapGetters, mapState} from "vuex";

    export default {
        name: "login",
        components: {LoginCambiarPassword, LoginPassowrd, LoginUser},
        data: () => ({
            miusuario: '',
            mipassword: null,
            cambioPass: false,
            userToken: ''
        }),
        mounted() {
        },
        methods: {
            setMiUsuario(parametro) {
                this.miusuario = parametro;
            },
            changePassword() {
                this.cambioPass = !this.cambioPass;
            },
            setToken(parametro) {
                this.userToken = parametro;
            },
            setMiPassword(parametro) {
                this.mipassword = parametro;
            },
        },
        computed: {
            ...
                mapState(['url_base']),
            ...mapGetters(['isLogin'])
        }
    }
</script>

<style scoped>

</style>